var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 3.2C0.716936 3.2 0 2.48306 0 1.6C0 0.716936 0.716936 0 1.6 0C2.48306 0 3.2 0.716936 3.2 1.6C3.2 2.48306 2.48306 3.2 1.6 3.2V3.2M1.6 8C0.716936 8 0 7.28306 0 6.4C0 5.51694 0.716936 4.8 1.6 4.8C2.48306 4.8 3.2 5.51694 3.2 6.4C3.2 7.28306 2.48306 8 1.6 8V8M1.6 12.8C0.716936 12.8 0 12.0831 0 11.2C0 10.3169 0.716936 9.6 1.6 9.6C2.48306 9.6 3.2 10.3169 3.2 11.2C3.2 12.0831 2.48306 12.8 1.6 12.8V12.8",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.d1c82362fe4b09724438f485faf93e01.svg";
export { ForwardRef as ReactComponent };